import { render, staticRenderFns } from "./SM-Class-List-Menu.vue?vue&type=template&id=3dda919a"
import script from "./SM-Class-List-Menu.vue?vue&type=script&lang=js"
export * from "./SM-Class-List-Menu.vue?vue&type=script&lang=js"
import style0 from "./SM-Class-List-Menu.vue?vue&type=style&index=0&id=3dda919a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports